define('home/views/BaseSuggestionView',[
    'backbone-marionette',
], function (
    Marionette
) {
    'use strict';

    /**
     * A view showing a single followable (with avatar, name, and follow button)
     */
    return Marionette.ItemView.extend({
        events: {
            'click [data-action=toggle-follow]': 'toggleFollow',
        },
        modelEvents: {
            'change:name': 'render',
            'change:isFollowing': 'handleFollowedClass',
        },

        handleFollowedClass: function () {
            this.$('[data-action=toggle-follow]').toggleClass('active', this.model.get('isFollowing'));
        },

        /**
         * Track event and toggle model, meant to be extended by concrete class
         * @param  {Event} evt            Event object
         * @param  {string} eventName   Provided by concrete class
         */
        toggleFollow: function (evt) {
            if (evt)
                evt.preventDefault();

            this.model.toggleFollowed();
        },
    });
});

